import { useEffect } from 'react';
import { Navbar } from '@/components/site/Navbar';
import { Footer } from '@/components/site/Footer';
import { Hero } from '@/components/site/Hero';
import { UniverseSection } from '@/components/site/UniverseSection';
import { ApplicationsTeaser } from '@/components/site/ApplicationsTeaser';
import { HowItWorks } from '@/components/site/HowItWorks';
import { Testimonials } from '@/components/site/Testimonials';
import { WaitlistCTA } from '@/components/site/WaitlistCTA';
import { MedlibQrBanner } from '@/components/site/MedlibQrBanner';
import { setPageMeta } from '@/lib/seo';
import { useT, useLang } from '@/lib/i18n';

export default function Home() {
  const t = useT();
  const { lang } = useLang();
  useEffect(() => {
    setPageMeta({
      title: t('seo.home_title'),
      description: t('seo.home_description'),
      path: '/',
    });
  }, [t, lang]);

  return (
    <div data-testid="page-home">
      <Navbar />
      <MedlibQrBanner />
      <main>
        <Hero />
        <UniverseSection />
        <ApplicationsTeaser />
        <HowItWorks />
        <Testimonials />
        <WaitlistCTA />
      </main>
      <Footer />
    </div>
  );
}
